import type { MaskConfig } from "./types";

/**
 * no mask - passes through input unchanged
 * used when the MaskedInput component is used without a mask
 */
export const noneMask = (): MaskConfig => ({
  cleaveOptions: {},
  placeholder: "",
  formatValue: (rawValue) => rawValue,
});
